export const TroubleshootingHook = {
  mounted() {
    this.handleEvent("send_diagnostic", async () => {
      sendMessage(JSON.stringify({ type: "diagnostic" }));
    });
    this.handleEvent("clear_cache", async () => {
      sendMessage(JSON.stringify({ type: "clear_cache" }));
    });
  },
};

async function sendMessage(message) {
  if (!navigator.serviceWorker.controller) {
    await navigator.serviceWorker.ready;
  }

  navigator.serviceWorker.controller?.postMessage(message);
}
